import * as $ from 'jquery';
import 'bootstrap';
import * as moment from 'moment';

export class searchFlightHotelSubmit {
	/**
	 * [searchFormValidation description]
	 * @param  {any} callback [description]
	 * @return {any}          [description]
	 */
	searchFormValidation($instance:any, $officeCode:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];
		$instance  = $instance.find('#flightHotel');
		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;


		let $fromLocation:any     = $instance.find('.fh-from--location'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input'),
			$passengerDetailsSelected: any = $('.passenger-details-selected'),
			$adultCount: any = parseInt($instance.find('select[name="adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="children_count"]').val()),
			$infantErrorSelector: any = $instance.find('.infant-error'),
			$passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount;

		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		// Validation: From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			let $fromLocValidate:any = $fromLocation.attr('data-departloc');
			$errorList.push('<strong>'+$fromLocation.parent().find('label.from-loc-label').text()+':</strong> '+$fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
		}

		let $toLocation:any     = $instance.find('.fh-to--location'),
			$toSelectize:any    = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: To Location empty field
		if ($toLocation.val() == '') {
			// $toSelectize.addClass('has-error');

			// let $toLocValidate:any = $toLocation.attr('data-destloc');
			// $errorList.push('<strong>'+$toLocation.parent().find('label.to-loc-label').text()+':</strong> '+$toLocValidate);
			// formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
		}

		// Validation: From/To Location identical value
		if ($fromLocation.val() === $toLocation.val()) {
			if ($toLocation.val() !== '') {
				$toSelectize.addClass('has-error');
				formDataValid = false;
			}

			if (!($fromLocation.val() == '' || $toLocation.val() == '')){
				let $fromLoLocValidate:any = $fromLocation.attr('data-deptDestLoc');
				$errorList.push('<strong>'+$fromLocation.parent().find('label').text() +', '+ $toLocation.parent().find('label').text()+':</strong> '+$fromLoLocValidate);
			}
        }
        
		let $departureDate:any = $instance.find('.departureDate'),
			$returnDate:any = $instance.find('.returnDate');
		
		// Departure Date empty field validation 
		if ($departureDate.val() == '') {
			$departureDate.parent().find('.departureDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if ($returnDate.val() == '') {
			$returnDate.parent().find('.returnDate').addClass('has-empty-error');
			let $travelEndDate:any = $instance.find('.returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
			formDataValid = false;
		} else {
			$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
		}

		//Validation - LHR (minimum 5 nights)
		let $cabinClass = $instance.find('.cabin-class').val();
		if ($fromLocation.val() != '' && $toLocation.val() != '' && $cabinClass == 'CFFBUS' && $departureDate.val() != '' && $returnDate.val() != '') {
			if ($fromLocation.val().split('_')[0].toUpperCase() === 'LHR' && $toLocation.val().split('-')[1].toUpperCase() === 'KUL') {
				let $formatDepDate: any = moment(new Date($departureDate.val()), 'DD/MM/YYYY');
				let $formatRetDate: any = moment(new Date($returnDate.val()), 'DD/MM/YYYY');
				if ($formatRetDate.diff($formatDepDate, 'days') < 5) {
					$departureDate.parent().find('.departureDate').addClass('has-empty-error');
					$returnDate.parent().find('.returnDate').addClass('has-empty-error');
					let $travelMinDate: any = $instance.find('.returnDate').attr('data-travelMinDays');
					$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelMinDate);
					formDataValid = false;
				}
				else {
					$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
					$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
				}
			}
			
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}

		/* Adult infant limit check */
		var adultChildComb = 0;
		$instance.find('.children-age').each(function (n:any) {
			var childAgeTemp = parseInt($(this).val());
				if(childAgeTemp < 2){
					adultChildComb++;
				}
			});
		if ($childrenCount > 0) {
			if(adultChildComb > $adultCount){
				$passengerDetailsSelected.show();
				$instance.find('.passenger-details').addClass('has-error');
				$errorList.push('<strong>'+$instance.find('.passenger-details').parent().find('label.date-form--title').text()+':</strong> ' +$passengerLimitErrorSelector.attr('data-adult-infant-limit'));
				formDataValid = false;
			}else{
				$passengerDetailsSelected.hide();
				$instance.find('.passenger-details').removeClass('has-error');
			}
		}
        
		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
	}
	searchFormValidationflightHotel($instance:any , $officeCode:any, callback:any){
		let _self = this;
		let $errorList:Array<string> = [];
		$instance = $instance.find('#flightHotel2');
		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;

		let $fromLocation: any =$instance.find('.fh-from--location__flighthotel'),
			$fromSelectize: any = $fromLocation.parent().find('.selectize-control .selectize-input'),
			$passengerDetailsSelected:any = $('.passenger-details-selected'),
			$adultCount: any = parseInt($instance.find('select[name="adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="child_count"]').val()),
			$infantErrorSelector: any = $instance.find('.infant-error'),
			$passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount,
			$hotelInputVal:any     = $instance.find('#hotelInput__flighthotel'),
			$hotelInputClass:any     = $instance.find('.hotelInputClass'),
			$hotelID:any    = $instance.find('#hotelInputVal').val();
		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		// Validation: From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			let $fromLocValidate: any = $fromLocation.attr('data-departloc');
			$errorList.push('<strong>'+$fromLocation.parent().find('label.from-loc-label').text()+':</strong> '+$fromLocValidate);
			formDataValid = false;
		}else{
			$fromSelectize.removeClass('has-error');
		}

		let $toLocation:any = $instance.find('.fh-to--location__flighthotel'),
			$toSelectize:any = $toLocation.parent().find('.selectize-control .selectize-input');
		
		// Validation: To Location empty field
		if ($toLocation.val() == '') {
			// $toSelectize.addClass('has-error');

			// let $toLocValidate:any = $toLocation.attr('data-destloc');
			// $errorList.push('<strong>'+$toLocation.parent().find('label.to-loc-label').text()+':</strong> '+$toLocValidate);
			// formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
		}

		// Validation: From/To Location identical value
		if ($fromLocation.val() === $toLocation.val()) {
			if ($toLocation.val() !== '') {
				$toSelectize.addClass('has-error');
				formDataValid = false;
			}

			if (!($fromLocation.val() == '' || $toLocation.val() == '')){
				let $fromLoLocValidate:any = $fromLocation.attr('data-deptDestLoc');
				$errorList.push('<strong>'+$fromLocation.parent().find('label').text() +', '+ $toLocation.parent().find('label').text()+':</strong> '+$fromLoLocValidate);
			}
        }
        
		let $departureDate:any = $instance.find('.departureDate'),
			$returnDate:any = $instance.find('.returnDate');

			if ($hotelID == '') {
				//	$fromSelectize.addClass('has-error');
					$hotelInputClass.addClass('has-error');
					$instance.find('#hotelInputWrap__flighthotel .dropdown-icon').addClass('has-error');
					let $hotelValidate:any = $hotelInputVal.attr('data-hotelMsg');
					$errorList.push('<strong>'+$hotelInputVal.parent().find('label').text()+':</strong> '+$hotelValidate);
					formDataValid = false;
				} else {
					$hotelInputClass.removeClass('has-error');
					$instance.find('#hotelInputWrap__flighthotel .dropdown-icon').removeClass('has-error');
				//	$fromBookingTitle.removeClass('has-error');
				}

		// Departure Date empty field validation 
		if ($departureDate.val() == '') {
			$departureDate.parent().find('.departureDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if ($returnDate.val() == '') {
			$returnDate.parent().find('.returnDate').addClass('has-empty-error');
			let $travelEndDate:any = $instance.find('.returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
			formDataValid = false;
		} else {
			$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
		}
		//Validation - LHR (minimum 5 nights)
		let $cabinClass = $instance.find('.cabin-class').val();
		if ($fromLocation.val() != '' && $toLocation.val() != '' && $cabinClass == 'CFFBUS' && $departureDate.val() != '' && $returnDate.val() != '') {
			if ($fromLocation.val().split('_')[0].toUpperCase() === 'LHR' && $toLocation.val().split('-')[1].toUpperCase() === 'KUL') {
				let $formatDepDate: any = moment(new Date($departureDate.val()), 'DD/MM/YYYY');
				let $formatRetDate: any = moment(new Date($returnDate.val()), 'DD/MM/YYYY');
				if ($formatRetDate.diff($formatDepDate, 'days') < 5) {
					$departureDate.parent().find('.departureDate').addClass('has-empty-error');
					$returnDate.parent().find('.returnDate').addClass('has-empty-error');
					let $travelMinDate: any = $instance.find('.returnDate').attr('data-travelMinDays');
					$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelMinDate);
					formDataValid = false;
				}
				else {
					$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
					$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
				}
			}
			
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}

		/* Adult infant limit check */
		var adultChildComb = 0;
		$instance.find('.children-age').each(function (n:any) {
			var childAgeTemp = parseInt($(this).val());
				if(childAgeTemp < 2){
					adultChildComb++;
				}
			});
		if ($childrenCount > 0) {
			if(adultChildComb > $adultCount){
				$passengerDetailsSelected.show();
				$instance.find('.passenger-details').addClass('has-error');
				$errorList.push('<strong>'+$instance.find('.passenger-details').parent().find('label.date-form--title').text()+':</strong> ' +$passengerLimitErrorSelector.attr('data-adult-infant-limit'));
				formDataValid = false;
			}else{
				$passengerDetailsSelected.hide();
				$instance.find('.passenger-details').removeClass('has-error');
			}
		}
        
		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
	}
	
	searchFormValidationdeals($instance:any, $officeCode:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];
		$instance  = $instance.find('#flightHotel_deals');
		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;


		let $fromLocation:any     = $instance.find('.fh-from--location_deals'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input'),
			$passengerDetailsSelected: any = $('.passenger-details-selected'),
			$adultCount: any = parseInt($instance.find('select[name="adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="children_count"]').val()),
			$infantErrorSelector: any = $instance.find('.infant-error'),
			$passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount;

		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		// Validation: From Location empty field
		if ($fromLocation.val() == '') {
			$fromSelectize.addClass('has-error');
			let $fromLocValidate:any = $fromLocation.attr('data-departloc');
			$errorList.push('<strong>'+$fromLocation.parent().find('label.from-loc-label').text()+':</strong> '+$fromLocValidate);
			formDataValid = false;
		} else {
			$fromSelectize.removeClass('has-error');
		}

		let $toLocation:any     = $instance.find('.fh-to--location_deals'),
			$toSelectize:any    = $toLocation.parent().find('.selectize-control .selectize-input');

		// Validation: To Location empty field
		if ($toLocation.val() == '') {
			// $toSelectize.addClass('has-error');

			// let $toLocValidate:any = $toLocation.attr('data-destloc');
			// $errorList.push('<strong>'+$toLocation.parent().find('label.to-loc-label').text()+':</strong> '+$toLocValidate);
			// formDataValid = false;
		} else {
			$toSelectize.removeClass('has-error');
		}

		// Validation: From/To Location identical value
		if ($fromLocation.val() === $toLocation.val()) {
			if ($toLocation.val() !== '') {
				$toSelectize.addClass('has-error');
				formDataValid = false;
			}

			if (!($fromLocation.val() == '' || $toLocation.val() == '')){
				let $fromLoLocValidate:any = $fromLocation.attr('data-deptDestLoc');
				$errorList.push('<strong>'+$fromLocation.parent().find('label').text() +', '+ $toLocation.parent().find('label').text()+':</strong> '+$fromLoLocValidate);
			}
        }
        
		let $departureDate:any = $instance.find('.departureDate'),
			$returnDate:any = $instance.find('.returnDate');
		
		// Departure Date empty field validation 
		if ($departureDate.val() == '') {
			$departureDate.parent().find('.departureDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if ($returnDate.val() == '') {
			$returnDate.parent().find('.returnDate').addClass('has-empty-error');
			let $travelEndDate:any = $instance.find('.returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
			formDataValid = false;
		} else {
			$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
		}
		//Validation - LHR (minimum 5 nights)
		let $cabinClass = $instance.find('.cabin-class').val();
		if ($fromLocation.val() != '' && $toLocation.val() != '' && $cabinClass == 'CFFBUS' && $departureDate.val() != '' && $returnDate.val() != '') {
			if ($fromLocation.val().split('_')[0].toUpperCase() === 'LHR' && $toLocation.val().split('-')[1].toUpperCase() === 'KUL') {
				let $formatDepDate: any = moment(new Date($departureDate.val()), 'DD/MM/YYYY');
				let $formatRetDate: any = moment(new Date($returnDate.val()), 'DD/MM/YYYY');
				if ($formatRetDate.diff($formatDepDate, 'days') < 5) {
					$departureDate.parent().find('.departureDate').addClass('has-empty-error');
					$returnDate.parent().find('.returnDate').addClass('has-empty-error');
					let $travelMinDate: any = $instance.find('.returnDate').attr('data-travelMinDays');
					$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelMinDate);
					formDataValid = false;
				}
				else {
					$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
					$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
				}
			}
			
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}

		/* Adult infant limit check */
		var adultChildComb = 0;
		$instance.find('.children-age').each(function (n:any) {
			var childAgeTemp = parseInt($(this).val());
				if(childAgeTemp < 2){
					adultChildComb++;
				}
			});
		if ($childrenCount > 0) {
			if(adultChildComb > $adultCount){
				$passengerDetailsSelected.show();
				$instance.find('.passenger-details').addClass('has-error');
				$errorList.push('<strong>'+$instance.find('.passenger-details').parent().find('label.date-form--title').text()+':</strong> ' +$passengerLimitErrorSelector.attr('data-adult-infant-limit'));
				formDataValid = false;
			}else{
				$passengerDetailsSelected.hide();
				$instance.find('.passenger-details').removeClass('has-error');
			}
		}
        
		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
	}
	toursearchFormValidation($instance:any, $officeCode:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];
		$instance  = $instance.find('#tour');
		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;


		let $fromLocation:any     = $instance.find('#tourInput'),
			$adultCount: any = parseInt($instance.find('select[name="transfer_adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="transfer_child_count"]').val()),
			$passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount,
			$fromInputVal:any     = $instance.find('#hotelInput'),
			$fromInputClass:any     = $instance.find('.hotelInputClass')
						
		if ($fromLocation.val() == '') {
		//	$fromSelectize.addClass('has-error');
			$fromInputClass.addClass('has-error');
			let $hotelValidate:any = $fromLocation.attr('data-tourmsg');
			$errorList.push('<strong>'+$fromLocation.parent().find('label').text()+':</strong> '+$hotelValidate);
			formDataValid = false;
		} else 
		{
			$fromInputVal.removeClass('has-error');
		}
		let $departureDate:any = $('#tour .departureDate'),
			$returnDate:any =  $('#tour .returnDate');
		
		// Departure Date empty field validation 
		if ($departureDate.val() == '' ) {
			$departureDate.parent().find('.departureDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if ($returnDate.val() == '') {
			$returnDate.parent().find('.returnDate').addClass('has-empty-error');
			let $travelEndDate:any = $returnDate.attr('data-travelRetdate');
			$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
			formDataValid = false;
		} else {
			$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}

		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
    }
	transfersearchFormValidation($instance:any, $officeCode:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];
		$instance  = $instance.find('#transfer');
		let $errorValidation = $instance.find('.error-validation').first();
		let formDataValid = true;


		let $fromLocation:any     = $instance.find('.pick-up--location'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input'),
			$passengerDetailsSelected: any = $('#transfer .passenger-details-selected'),
			$adultCount: any = parseInt($instance.find('select[name="transfer_adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="transfer_child_count"]').val()),
			$passengerLimitErrorSelector: any = $instance.find('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount,
			$pickupInputVal:any     = $instance.find('.pick-up #hotelInput'),
			$pickupInputClass:any     = $instance.find('.pick-up .hotelInputClass'),
			$dropoffInputVal:any     = $instance.find('.drop-off #hotelInput'),
			$dropoffInputClass:any     = $instance.find('.drop-off .hotelInputClass')
		let $pickID:any    = $instance.find('.pick-up #hotelInputVal').val();
		let $dropID:any    = $instance.find('.drop-off #hotelInputVal').val();			
		let journeytype  = $("#transfer-options input[type='radio']:checked").val();				
		if ($pickID == '') {
		//	$fromSelectize.addClass('has-error');
			$pickupInputClass.addClass('has-error');
			let $hotelValidate:any = $pickupInputVal.attr('data-pickMsg');
			$errorList.push('<strong>'+$pickupInputVal.parent().find('label').text()+':</strong> '+$hotelValidate);
			formDataValid = false;
		} else 
		{
			$pickupInputVal.removeClass('has-error');
		}
		if ($dropID == '') {
			//	$fromSelectize.addClass('has-error');
				$dropoffInputClass.addClass('has-error');
				let $hotelValidate:any = $dropoffInputVal.attr('data-dropMsg');
				$errorList.push('<strong>'+$dropoffInputVal.parent().find('label').text()+':</strong> '+$hotelValidate);
				formDataValid = false;
			} else 
			{
				$dropoffInputVal.removeClass('has-error');
			}
		let $departureDate:any = $('#transfer .departuretransferDate'),
			$returnDate:any =  $('#transfer .returntransferDate');
		
		// Departure Date empty field validation 
		if ($departureDate.val() == '' || $departureDate.val().length <= 17) {
			$departureDate.parent().find('.departuretransferDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departuretransferDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if(journeytype == 'Return'){
			if ($returnDate.val() == '' || $returnDate.val().length <= 17) {
				$returnDate.parent().find('.returntransferDate').addClass('has-empty-error');
				let $travelEndDate:any = $returnDate.attr('data-travelRetdate');
				$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
				formDataValid = false;
			} else {
				$returnDate.parent().find('.returntransferDate').removeClass('has-empty-error');
			}
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}

		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
    }
    mholidaysDeeplink($instance: any): any {
        let $departureStationCode = $instance.find('.fh-from--location').val();
        let $arrivalCityCode = $instance.find('.fh-to--location').val();
        let $departureStationName = $instance.find('.fh-from--location option').text();
        let $arrivalCityName = $instance.find('.fh-to--location option').text();

        let $getDepartureDate = $instance.find('.departureDate').val();
		let $arrivalCityCodeArray:any = $arrivalCityCode.split('-');
        let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
        let $getReturnDate = $instance.find('.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let currencyCode = $("#currencyCode").val();
		let mhholidaysTripFlowUrl = $("#mhholidaysTripFlowUrl").val();

        let $childSel: any;

        let $adultCount = parseInt($instance.find('.adults-count').val());
        let $childCount = parseInt($instance.find('.children-count').val());

        let $data = {
            engine: 'package',
            //DepartureMonth
            DateType: 'exact',
            //DurationMin: 2,
            Adults: $adultCount,
            travelTypel: 'package',
            priceType: 'bothTotal',
            Price: '0-10000',
            RatingName: 'overallAverageRating',
            RatingOperator: 'ge',
            SortingOrder: 'categoryDESC',
            grouped: '1',
			init: '1',
			DurationMin: 'range'
        }

        if ($childCount > 0) {
            $data['Children'] = $childCount;
        }

        $departureStationName = $departureStationName.split(',');
        $departureStationName = $departureStationName[0];
        $departureStationName = $departureStationName.replace(/\s+/g, '+');
        $arrivalCityName = $arrivalCityName.split(',');
        $arrivalCityName = $arrivalCityName[0];
        $arrivalCityName = $arrivalCityName.replace(/\s+/g, '+');
        $data['DepartureAirports'] = {};
		$data['DepartureAirports'][$departureStationName] = $departureStationCode;
		
		//Set region for penang, Bali and Phuket
		if ($arrivalCityCode !== "") {
			if ($arrivalCityCodeArray[1] == 'PEN') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName] = $arrivalCityCodeArray[0];
			} else if ($arrivalCityCodeArray[1] === 'DPS') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName.split('-')[1]] = '1182';
			} else if ($arrivalCityCodeArray[1] === 'HKT') {
				$data['Region'] = {};
				$data['Region'][$arrivalCityName] = '10427222';
			} else {
				$data['City'] = {};
				$data['City'][$arrivalCityName] = $arrivalCityCodeArray[0];
			}
		}
        //Cabin class
        $data['Rating'] = {};
        $data['Child'] = {};

        $instance.find('.children-age').each(function (n:any) {
            $data['Child'][n] = $(this).val();
        });

        let $flightSearchDeepLink = $.param($data);
        $flightSearchDeepLink = $flightSearchDeepLink.replace(/%2B/g, '+');
        $flightSearchDeepLink = $flightSearchDeepLink.replace(/-+/g, '%2C');
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl + currencyCode.toLowerCase()+'?DepartureDate=' + $departureDate + '&ReturnDate=' + $returnDate + '&' + $flightSearchDeepLink;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	tourDeeplink($instance: any): any {

		let $getDepartureDate = $instance.find('#tour .departureDate').val()
		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $getReturnDate = $instance.find('#tour .returnDate').val()
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $tourInputVal:any   = $instance.find('#tourInputVal').val();
		let $CultureCode:any='en-US';
		let $currencyCode = $("#currencyCode").val();
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
			let $data = {
			"To":$tourInputVal,
			'DepartureDate':$departureDate,
			'ReturnDate':$returnDate,
			'CultureCode':$CultureCode,
			'Currency':$currencyCode,
			'RoomCount':'1',
			'PaxInfos[0].AdultCount':1,
			'ProductId':'06fa757e-0e0d-46ad-913e-acbb422e139b'
		}

		
	    let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/search-tour';
        let $flightSearchDeepLink = $.param($data);
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl +'?'+ $flightSearchDeepLink;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	transferDeeplink($instance: any): any {

		let $getDepartureDate = $instance.find('.departuretransferDate').val().substring(0, 11);
		let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
		let $departureDatetime=$instance.find('.departuretransferDate').val().substring(12, 19);
		let $getReturnDate = $instance.find('.returntransferDate').val().substring(0, 11)
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $returnDatetime=$instance.find('.returntransferDate').val().substring(12, 19);
		let $adultCount = parseInt($('#transfer_adults_count').val());
		let $childCount = parseInt($instance.find('#transfer_child_count').val());
		var $toVal:any     = $('#transferdrop #hotelInputtoVal').val();
		var $geoCoors:any     = $('#transferdrop #geo-coords').val();	
		let currencyCode = $("#currencyCode").val();	
		let journeytype  = $("#transfer-options input[type='radio']:checked").val();	
		let $hotelInputVal:any   = $('#transferdrop  #hotelInputVal').val();
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		// convert 12 hour to 24  hour

		if(journeytype == 'ToAirport')
		{
			 $toVal           = $('#transferpickup #hotelInputtoVal').val();
			 $geoCoors        = $('#transferpickup #geo-coords').val();	
			 $hotelInputVal   = $('#transferpickup  #hotelInputVal').val();
		}
		var AMPM = $departureDatetime.slice(-2);
		var timeArr = $departureDatetime.slice(0, -2).split(":");
		if (AMPM === "AM" && timeArr[0] === "12") 
		{
			timeArr[0] = "00";
		} else if (AMPM === "PM") {
			timeArr[0] = (timeArr[0] % 12) + 12
		}  
		var formatpicktime=timeArr.join(":");
		if(timeArr[0].length==1){
			formatpicktime = "0"+formatpicktime;
		}
		AMPM = $returnDatetime.slice(-2);
		timeArr = $returnDatetime.slice(0, -2).split(":");
		if (AMPM === "AM" && timeArr[0] === "12") 
		{
			timeArr[0] = "00";
		} else if (AMPM === "PM") {
			timeArr[0] = (timeArr[0] % 12) + 12
		}  
		var formatdroptime=timeArr.join(":");
		if(timeArr[0].length==1){
			formatdroptime = "0"+formatdroptime;
		}
		let mhholidaysTripFlowUrl:any;
		

			let $data = {
			'TransferSearchInfo.TravelTime':formatpicktime,	
			'TransferSearchInfo.TransferType':journeytype,
			'TransferSearchInfo.AccommodationGeoCoords': $geoCoors,
			'DepartureDate':$departureDate,
			// 'ReturnDate':$returnDate,
			'PaxInfos[0].AdultCount':$adultCount,
			'PaxInfos[0].ChildCount':$childCount,
			'Currency':currencyCode,
			'CultureCode':'en-US',
			'RoomCount':'1',
			'ProductId':'ed4718c2-5afd-4d4d-a49e-f2cf68fbe93e',
			'To': $toVal
		}
		if(journeytype == 'Return'){	
			$data['ReturnDate'] = $returnDate;	
			$data['TransferSearchInfo.ReturnTime'] = formatdroptime;
		}
		let $childSel:any;
		var childCount = 0;
		$data['PaxInfos[0].ChildAges'] = {};
		for ($childSel=1; $childSel <= $childCount; $childSel++)
			{
				var childAgeTemp = $('#child_age_list_room_transfer'+childCount+'  #child_age').val()
					$data['PaxInfos[0].ChildAges'][childCount] = childAgeTemp;
					childCount++
			}
		
	    mhholidaysTripFlowUrl =mhHolidaysDeeplinkBaseURL+'/package/search-transfer';
        let $flightSearchDeepLink = $.param($data);
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl +'?'+ $flightSearchDeepLink+'&TransferSearchInfo.RegionId=H%3A'+$hotelInputVal;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	mholidaysDeeplinkdeals($instance: any): any {
        let $departureStationCode = $instance.find('.fh-from--location_deals').val();
		let $arrivalCityCode = $instance.find('.fh-to--location_deals').val();
		let $arrivalCityCodeArray:any = $arrivalCityCode.split('-');
		if($arrivalCityCodeArray.length==2)
		{
			 $arrivalCityCode=$arrivalCityCodeArray[1]
		}
		else
		{
			$arrivalCityCode=$arrivalCityCodeArray[0]
		}
        let $getDepartureDate = $instance.find('.departureDate').val();
        let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
        let $getReturnDate = $instance.find('.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/search'
		let $currencyCode = $("#currencyCode").val();
		let $cabinClass = $instance.find('.cabin-class').val()

		if($cabinClass=="CFFFIRST"){
			$cabinClass= "3"
		} 
		else if($cabinClass=="CFFBUS"){
			$cabinClass= "2"
		} 
		else if($cabinClass =="CFFECO"){
			$cabinClass= "1"
		} 
		// Room count 
		let room2Adult:any = parseInt($('#room2_adults_count_deals').val()) || 0;
		let room3Adult:any = parseInt($('#room3_adults_count_deals').val()) || 0;
		let totalRoomCount:any = 1;
		if(!$('#flightHotel_deals .room_two').hasClass('hide'))
		{
			totalRoomCount++;
		}
		if(!$('#flightHotel_deals .room_three').hasClass('hide'))
		{
			totalRoomCount++;
		}

			let $data = {
			'From':$departureStationCode,
			'To': $arrivalCityCode,
			'DepartureDate':$departureDate,
			'ReturnDate':$returnDate,
			'CabinClass':$cabinClass,
			'CultureCode':'en-US',
			'Currency':$currencyCode,
			'JourneyType':'1',
			'RoomCount':totalRoomCount,
			'ProductId':'f4fc4fdf-39ef-4978-ac62-3be1a42267c7',
			'DealProductType':'FlightHotel',
			'DealSettingId':'0953b524-d892-4068-b05e-7cb77f85667f'
		}
	/* Room 1 ,2,3, Pax details*/
	let adultCntArray:Array<any>  = [];
	let childCntArray:Array<any>  = [];
	let infantCntArray:Array<any> = [];

	adultCntArray.push(parseInt($('#room1_adults_count_deals').val()) || 0);
	if(!$('#flightHotel_deals .room_two').hasClass('hide'))
	{
		adultCntArray.push(parseInt($('#room2_adults_count_deals').val()) || 0);
	}
	if(!$('#flightHotel_deals .room_three').hasClass('hide'))
	{
		adultCntArray.push(parseInt($('#room3_adults_count_deals').val()) || 0);
	}
	childCntArray.push(parseInt($('#room1_child_count_deals').val()) || 0);
	childCntArray.push(parseInt($('#room2_child_count_deals').val()) || 0);
	childCntArray.push(parseInt($('#room3_child_count_deals').val()) || 0);

	infantCntArray.push(parseInt($('#room1_infants_count_deals').val()) || 0) ;
	infantCntArray.push(parseInt($('#room2_infants_count_deals').val()) || 0) ;
	infantCntArray.push(parseInt($('#room3_infants_count_deals').val()) || 0) ;

	for ( var k = 0 ; k < 3 ; k++){
		var j = k + 1;
		var m = 0 ;
	  if(adultCntArray[k] > 0){
		  $data['PaxInfos['+k+'].AdultCount'] = adultCntArray[k];
		  if(infantCntArray[k] > 0){
			  $data['PaxInfos['+k+'].InfantCount'] = infantCntArray[k];
		  }
		  if(childCntArray[k] > 0){
			  $data['PaxInfos['+k+'].ChildCount'] =childCntArray[k];
			  $instance.find('#child_age_list_room'+j+'_deals'+' #child_age').each(function () {      
					  $data['PaxInfos['+k+'].ChildAges['+m+']']= this.value;
					  m++;
				  });
		  }
	  }
  }
	    mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/search';
        let $flightSearchDeepLink = $.param($data);
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl +'?'+ $flightSearchDeepLink;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	mholidaysDeeplinkflighthotel($instance: any): any {
        let $departureStationCode = $instance.find('.fh-from--location__flighthotel').val();
		let $arrivalCityCode = $instance.find('.fh-to--location__flighthotel').val();
		let $arrivalCityCodeArray:any = $arrivalCityCode.split('-');
		let $hotelInputVal:any   = $instance.find('#hotelInputVal').val();
		let $hotelInputtoVal:any   = $instance.find('#hotelInputtoVal').val();
		let searchtype:any;
		if($arrivalCityCodeArray.length==2)
		{
			 $arrivalCityCode=$arrivalCityCodeArray[1]
		}
		else
		{
			$arrivalCityCode=$arrivalCityCodeArray[0]
		}
        let $getDepartureDate = $instance.find('#searchFlightDepart__flighthotel.departureDate').val();
        let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
        let $getReturnDate = $instance.find('#searchFlightReturn__flighthotel.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/start-search'
		let $currencyCode = $("#currencyCode").val();
		let $cabinClass = $instance.find('.cabin-class').val()

		if($cabinClass=="CFFFIRST"){
			$cabinClass= "3"
		} 
		else if($cabinClass=="CFFBUS"){
			$cabinClass= "2"
		} 
		else if($cabinClass =="CFFECO"){
			$cabinClass= "1"
		} 
		// Room count 
		let room2Adult:any = parseInt($('#room2_adults_count__flighthotel').val()) || 0;
		let room3Adult:any = parseInt($('#room3_adults_count__flighthotel').val()) || 0;
		let totalRoomCount:any = 1;
		if(!$('#flightHotel2 .room_two').hasClass('hide'))
		{
			totalRoomCount++;
		}
		if(!$('#flightHotel2 .room_three').hasClass('hide'))
		{
			totalRoomCount++;
		}

		// productID
		let productId = $('[data-ond-hotel-productID]').data('ondHotelProductid');
		if(typeof productId == 'undefined' || productId == null){
			productId = 'a3fe407a-2347-40cd-90b7-7d18b1a1fdc3'
		}
		//  Custom Deal Setting ID
		let dealSettingId = $('[data-deal-settingID-PDP]').data('dealSettingidPdp')
		if(typeof dealSettingId == 'undefined' || dealSettingId == null){
			dealSettingId = 'ef0ccb48-4914-4363-84e2-9d3f7e835de5'
		}

			let $data = {
			'From':$departureStationCode,
			'To': $arrivalCityCode,
			'DepartureDate':$departureDate,
			'ReturnDate':$returnDate,
			'CabinClass':$cabinClass,
			'CultureCode':'en-US',
			'Currency':$currencyCode,
			'JourneyType':'1',
			'RoomCount':totalRoomCount,
			'ProductId': productId, //'f4fc4fdf-39ef-4978-ac62-3be1a42267c7',
			'DealProductType':'FlightHotel',
			'DealSettingId': dealSettingId //'ef0ccb48-4914-4363-84e2-9d3f7e835de5'
			
		}

		if($hotelInputVal == "0"){
			searchtype = 'search-hotel';
		}else{
			$data['hotelcode'] = $hotelInputVal;
			searchtype = 'start-search';
		}
		
		/* Room 1 ,2,3, Pax details*/
		let adultCntArray:Array<any>  = [];
		let childCntArray:Array<any>  = [];
		let infantCntArray:Array<any> = [];

		adultCntArray.push(parseInt($('#room1_adults_count__flighthotel').val()) || 0);
		if(!$('#flightHotel2 .room_two').hasClass('hide'))
		{
			adultCntArray.push(parseInt($('#room2_adults_count__flighthotel').val()) || 0);
		}
		if(!$('#flightHotel2 .room_three').hasClass('hide'))
		{
			adultCntArray.push(parseInt($('#room3_adults_count__flighthotel').val()) || 0);
		}
		childCntArray.push(parseInt($('#room1_child_count__flighthotel').val()) || 0);
		childCntArray.push(parseInt($('#room2_child_count__flighthotel').val()) || 0);
		childCntArray.push(parseInt($('#room3_child_count__flighthotel').val()) || 0);

		infantCntArray.push(parseInt($('#room1_infants_count__flighthotel').val()) || 0) ;
		infantCntArray.push(parseInt($('#room2_infants_count__flighthotel').val()) || 0) ;
		infantCntArray.push(parseInt($('#room3_infants_count__flighthotel').val()) || 0) ;

		for ( var k = 0 ; k < 3 ; k++){
			var j = k + 1;
			var m = 0 ;
		if(adultCntArray[k] > 0){
			$data['PaxInfos['+k+'].AdultCount'] = adultCntArray[k];
			if(infantCntArray[k] > 0){
				$data['PaxInfos['+k+'].InfantCount'] = infantCntArray[k];
			}
			if(childCntArray[k] > 0){
				$data['PaxInfos['+k+'].ChildCount'] =childCntArray[k];
				$instance.find('#child_age_list_room'+j+'_hotel'+' #child_age').each(function () {      
						$data['PaxInfos['+k+'].ChildAges['+m+']']= this.value;
						m++;
					});
			}
		}
 	}
	    mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/start-search';
        let $flightSearchDeepLink = $.param($data);
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl +'?'+ $flightSearchDeepLink;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	mholidaysDeeplinknew($instance: any): any {
        let $departureStationCode = $instance.find('.fh-from--location').val();
		let $arrivalCityCode = $instance.find('.fh-to--location').val();
		let $arrivalCityCodeArray:any = $arrivalCityCode.split('-');
		if($arrivalCityCodeArray.length==2)
		{
			 $arrivalCityCode=$arrivalCityCodeArray[1]
		}
		else
		{
			$arrivalCityCode=$arrivalCityCodeArray[0]
		}
        let $getDepartureDate = $instance.find('.departureDate').val();
        let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
        let $getReturnDate = $instance.find('.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();
		let mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/search'
		let $currencyCode = $("#currencyCode").val();
		let $cabinClass = $instance.find('.cabin-class').val()

		if($cabinClass=="CFFFIRST"){
			$cabinClass= "3"
		} 
		else if($cabinClass=="CFFBUS"){
			$cabinClass= "2"
		} 
		else if($cabinClass =="CFFECO"){
			$cabinClass= "1"
		} 
		// Room count 
		let room2Adult:any = parseInt($('#room2_adults_count').val()) || 0;
		let room3Adult:any = parseInt($('#room3_adults_count').val()) || 0;
		let totalRoomCount:any = 1;

		// Product ID
		let productId = $('[data-campaign-ond-productID]').data('campaignOndProductid');
		if(typeof productId == 'undefined' || productId==null){
			productId = 'f4fc4fdf-39ef-4978-ac62-3be1a42267c7'
		}

		if(!$('#flightHotel .room_two').hasClass('hide'))
		{
			totalRoomCount++;
		}
		if(!$('#flightHotel .room_three').hasClass('hide'))
		{
			totalRoomCount++;
		}

			let $data = {
			'From':$departureStationCode,
			'To': $arrivalCityCode,
			'DepartureDate':$departureDate,
			'ReturnDate':$returnDate,
			'CabinClass':$cabinClass,
			'CultureCode':'en-US',
			'Currency':$currencyCode,
			'JourneyType':'1',
			'RoomCount':totalRoomCount,
			'ProductId':productId // 'f4fc4fdf-39ef-4978-ac62-3be1a42267c7'
		}
	/* Room 1 ,2,3, Pax details*/
	let adultCntArray:Array<any>  = [];
	let childCntArray:Array<any>  = [];
	let infantCntArray:Array<any> = [];

	adultCntArray.push(parseInt($('#room1_adults_count').val()) || 0);
	adultCntArray.push(parseInt($('#room2_adults_count').val()) || 0);
	adultCntArray.push(parseInt($('#room3_adults_count').val()) || 0);

	childCntArray.push(parseInt($('#room1_child_count').val()) || 0);
	childCntArray.push(parseInt($('#room2_child_count').val()) || 0);
	childCntArray.push(parseInt($('#room3_child_count').val()) || 0);

	infantCntArray.push(parseInt($('#room1_infants_count').val()) || 0) ;
	infantCntArray.push(parseInt($('#room2_infants_count').val()) || 0) ;
	infantCntArray.push(parseInt($('#room3_infants_count').val()) || 0) ;

	for ( var k = 0 ; k < 3 ; k++){
		  var j = k + 1;
		  var m = 0 ;
		if(adultCntArray[k] > 0){
			$data['PaxInfos['+k+'].AdultCount'] = adultCntArray[k];
			if(infantCntArray[k] > 0){
				$data['PaxInfos['+k+'].InfantCount'] = infantCntArray[k];
			}
			if(childCntArray[k] > 0){
				$data['PaxInfos['+k+'].ChildCount'] =childCntArray[k];
				$instance.find('#child_age_list_room'+j+' #child_age').each(function () {      
						$data['PaxInfos['+k+'].ChildAges['+m+']']= this.value;
						m++;
					});
			}
		}
	}

	    mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/search';
        let $flightSearchDeepLink = $.param($data);
        //Demo url http://demo-ibe.peakwork.com:8195/?
        let $flightSearchDeepLinkEncoded = mhholidaysTripFlowUrl +'?'+ $flightSearchDeepLink;
        console.log("##Redirect URL: " + $flightSearchDeepLinkEncoded);
        window.location.href = $flightSearchDeepLinkEncoded;
	}
	hotelSearchFormValidation($instance:any, $officeCode:any, callback:any):any {
		let _self = this;
		let $errorList:Array<string> = [];
		let $errorValidation = $instance.find('#hotel .error-validation').first();
		let formDataValid = true;
		$instance    = $instance.find('#hotel');

		let $fromLocation:any     = $instance.find('.fh-from--location'),
			$fromSelectize:any    = $fromLocation.parent().find('.selectize-control .selectize-input'),
			$passengerDetailsSelected: any = $instance.find('.passenger-details-selected'),
			$adultCount: any = parseInt($instance.find('select[name="adults_count"]').val()),
			$childrenCount: any = parseInt($instance.find('select[name="children_count"]').val()),
			$infantErrorSelector: any = $instance.find('.infant-error'),
			$passengerLimitErrorSelector: any = $('.passenger-limit-error'),
			$totalTravellersCount: any = $adultCount + $childrenCount,
			$hotelInputVal:any     = $instance.find('#hotelInput'),
			$hotelInputClass:any     = $instance.find('.hotelInputClass'),
			$hotelID:any    = $instance.find('#hotelInputVal').val();
			
			
			if ($hotelID == '') {
			//	$fromSelectize.addClass('has-error');
				$hotelInputClass.addClass('has-error');
				let $hotelValidate:any = $hotelInputVal.attr('data-hotelMsg');
				$errorList.push('<strong>'+$hotelInputVal.parent().find('label').text()+':</strong> '+$hotelValidate);
				formDataValid = false;
			} else {
				$hotelInputClass.removeClass('has-error');
			//	$fromBookingTitle.removeClass('has-error');
			}
		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');
        
		let $departureDate:any = $instance.find('.departureDate'),
			$returnDate:any = $instance.find('.returnDate');
		
		// Departure Date empty field validation 
		if ($departureDate.val() == '') {
			$departureDate.parent().find('.departureDate').addClass('has-empty-error');
			let $travelDate:any = $departureDate.attr('data-travelDepdate');
			$errorList.push('<strong>'+$departureDate.parent().find('label.date-form--title').text()+':</strong> '+$travelDate);
			formDataValid = false;
		} else {
			$departureDate.parent().find('.departureDate').removeClass('has-empty-error');
		}
		//Return Date empty field validation 
		if ($returnDate.val() == '') {
			$returnDate.parent().find('.returnDate').addClass('has-empty-error');
			let $travelEndDate:any = $instance.find('.returnDate').attr('data-travelRetdate');
			$errorList.push('<strong>'+$returnDate.parent().find('label.date-form--title').text()+':</strong> '+$travelEndDate);
			formDataValid = false;
		} else {
			$returnDate.parent().find('.returnDate').removeClass('has-empty-error');
		}

		if ($totalTravellersCount > 9) {
			$errorList.push($passengerLimitErrorSelector.attr('data-passenger-limit'));
			formDataValid = false;
		}
		/* Adult infant limit check */
		var adultChildComb = 0;
		$instance.find('.children-age').each(function (n:any) {
			var childAgeTemp = parseInt($(this).val());
				if(childAgeTemp < 2){
					adultChildComb++;
				}
			});
			
			if ($childrenCount > 0) {
				if(adultChildComb > $adultCount){
					$passengerDetailsSelected.show();
					$instance.find('.passenger-details').addClass('has-error');
					$errorList.push('<strong>'+$passengerDetailsSelected.parent().find('label.date-form--title').text()+':</strong> ' +$passengerLimitErrorSelector.attr('data-adult-infant-limit'));
					formDataValid = false;
				}else{
					$passengerDetailsSelected.hide();
					$instance.find('.passenger-details').removeClass('has-error');
				}
			}

		let $validationContainer:any = $errorValidation.find(".validation-content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
		let $validationMessagelist:any = $validationContainer;

		for (var i=0, len=$errorList.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + $errorList[i] + '</li>');
		}

		if (formDataValid) {
            $errorValidation.hide();
			// proceed to retrieve input vars (callback fn)
			if (typeof callback === "function") {
				callback($officeCode);
			}
		} else {
            $errorValidation.show();
			return false;
        }
    }
    
    mholidaysHotelDeeplink($instance: any): any {
		let $hotelInputVal:any   = $instance.find('#hotel #hotelInputVal').val();
		let $hotelInputtoVal:any   = $instance.find('#hotel #hotelInputtoVal').val();
		$instance    = $instance.find('#hotel');
        let $getDepartureDate = $instance.find('.departureDate').val();
        let $departureDate = moment(new Date($getDepartureDate)).format('YYYY-MM-DD');
        let $getReturnDate = $instance.find('.returnDate').val();
		let $returnDate = moment(new Date($getReturnDate)).format('YYYY-MM-DD');
		let $CultureCode='en-US';
		let $currencyCode = $("#currencyCode").val();
		let mhholidaysTripFlowUrl = $("#mhholidaysTripFlowUrl").val();
		let mhHolidaysDeeplinkBaseURL = $('#mhHolidaysDeeplinkBaseURL').val();

		// Room count 
		let room2Adult:any = parseInt($('#room2_adults_count_hotel').val()) || 0;
		let room3Adult:any = parseInt($('#room3_adults_count_hotel').val()) || 0;
		let totalRoomCount:any = 1;
		let searchtype:any;

		// productID
		let productId = $('[data-campaign-hotel-list-productID]').data('campaignHotelListProductid');
		if(typeof productId == 'undefined' || productId==null){
			productId = 'a3fe407a-2347-40cd-90b7-7d18b1a1fdc3'
		}
		if(!$('#hotel .room_two').hasClass('hide'))
		{
			totalRoomCount++;
		}
		if(!$('#hotel .room_three').hasClass('hide'))
		{
			totalRoomCount++;
		}
	   let $data = {
			To : $hotelInputtoVal,
		   CultureCode:$CultureCode,
		   Currency: $currencyCode,
		   'RoomCount':totalRoomCount,
		   'ProductId':productId,
		// 'ProductId':'a3fe407a-2347-40cd-90b7-7d18b1a1fdc3'
	   }
    if($hotelInputVal == "0"){
		searchtype = 'search-hotel';
	}else{
		$data['hotelcode'] = $hotelInputVal;
		searchtype = 'start-search';
	}
	   /* Room 1 ,2,3, Pax details*/
	let adultCntArray:Array<any>  = [];
	let childCntArray:Array<any>  = [];
	let infantCntArray:Array<any>  = [];

	adultCntArray.push(parseInt($('#room1_adults_count_hotel').val()) || 0);
	if(!$('#hotel .room_two').hasClass('hide'))
	{
		adultCntArray.push(parseInt($('#room2_adults_count_hotel').val()) || 0);
	}
	if(!$('#hotel .room_three').hasClass('hide'))
	{
		adultCntArray.push(parseInt($('#room3_adults_count_hotel').val()) || 0);
	}
	


	childCntArray.push(parseInt($('#room1_child_count_hotel').val()) || 0);
	childCntArray.push(parseInt($('#room2_child_count_hotel').val()) || 0);
	childCntArray.push(parseInt($('#room3_child_count_hotel').val()) || 0);

	infantCntArray.push(parseInt($('#room1_infants_count_hotel').val()) || 0) ;
	infantCntArray.push(parseInt($('#room2_infants_count_hotel').val()) || 0) ;
	infantCntArray.push(parseInt($('#room3_infants_count_hotel').val()) || 0) ;

	for ( var k = 0 ; k < 3 ; k++){
		  var j = k + 1;
		  var m = 0 ;
		if(adultCntArray[k] > 0){
			$data['PaxInfos['+k+'].AdultCount'] = adultCntArray[k];
			if(infantCntArray[k] > 0){
				$data['PaxInfos['+k+'].InfantCount'] = infantCntArray[k];
			}
			if(childCntArray[k] > 0){
				$data['PaxInfos['+k+'].ChildCount'] =childCntArray[k];
				$instance.find('#child_age_list_room'+j+'_hotel #child_age').each(function () {      
					    $data['PaxInfos['+k+'].ChildAges['+m+']']= this.value;
						m++;
					});
			}
		}
	}

	   let $tripFlowUrl  = $.param($data);
	   mhholidaysTripFlowUrl = mhHolidaysDeeplinkBaseURL+'/package/'+searchtype;
	   let $tripflow_encryptURL = mhholidaysTripFlowUrl+'?DepartureDate=' + $departureDate + '&ReturnDate=' + $returnDate + '&' + $tripFlowUrl;
	   console.log("##Redirect URL: "+ $tripflow_encryptURL);
	   window.location.href = $tripflow_encryptURL;

    }
}